import GifLoader from '@components/GifLoader'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material'
import GradientBtn from '@ui/GradientBtn'
import React, { useEffect, useState } from 'react'
import { Progress } from "react-sweet-progress";
import { ClipLoader } from 'react-spinners'
import { ExpandMore } from '@mui/icons-material'
import NothingFound from '@components/NothingFound'
import { useForm } from 'react-hook-form'
import api from "@utils/api";
import styles from "../../src/layout/explore-grid/style.module.scss";
import ItemsGrid from '@components/ItemsGrid'
import drawGIF from "@assets/uecomix-gifs/DRAW.webp";
import bonkGIF from "@assets/uecomix-gifs/bonk.webp";
import classNames from "classnames";
import { faCoins } from "@fortawesome/free-solid-svg-icons";
import { useMediaQuery } from "react-responsive";

const StoryBoard = () => {
    const {
        register: registerStoryboard,
        handleSubmit: handleSubmitStoryboard,
        control: controlStoryboard,
        formState: { errors: errorsStoryboard },
    } = useForm();

    // Second form
    const {
        register: registerGeneration,
        handleSubmit: handleSubmitGeneration,
        control: controlGeneration,
        formState: { errors: errorsGeneration },
    } = useForm();

    const [isLoading, setIsLoading] = useState(false);
    const [generateComicData, setGenerateComicData] = useState({});
    const [creditScore, setCreditScore] = useState("0");
    const [progress, setProgress] = useState(0);
    const [isLoader, setIsLoader] = useState(false);
    const [loaderStatus, setLoaderStatus] = useState("active");
    const [isLoadingForGeneration, setIsLoadingForGeneration] = useState(false);
    const [generateComicDataForGeneration, setGenerateComicDataForGeneration] =
        useState({});
    const [progressForGeneration, setProgressForGeneration] = useState(0);
    const [isLoaderForGeneration, setIsLoaderForGeneration] = useState(false);
    const [loaderStatusForGeneration, setLoaderStatusForGeneration] =
        useState("active");
    const [selectedImageSize, setSelectedImageSize] = useState(null);
    const [selectedImageStyle, setSelectedImageStyle] = useState(null);
    const [selectedImageGender, setSelectedImageGender] = useState(null);
    const [reqImageSize, setReqImageSize] = useState(false);
    const [reqImageStyle, setReqImageStyle] = useState(false);
    const [reqImageGender, setReqImageGender] = useState(false);
    const [creationStyle, setCreationStyle] = useState(false);
    const token = localStorage.getItem("token");

    const onSubmitStoryBoard = (data) => {
        const prompt = data.prompt;
        // const image_size = selectedOption?.value;
        // if (!image_size) {
        //     return setReqImageSize(true);
        // }
        setGenerateComicData({});
        // setReqImageSize(false);
        setIsLoading(true);
        setIsLoader(true);
        setProgress(true);
        setLoaderStatus("active");

        // update progress of progress bar every 200 milliseconds
        const progressInterval = setInterval(() => {
            setProgress((prevProgress) => {
                const newProgress = prevProgress + 1;
                return newProgress > 100 ? 100 : newProgress;
            });
        }, 200);

        // create-storyboard API will be execute
        const headers = { Authorization: `Bearer ${token}` };
        api
            .post("/create-storyboard", { prompt }, { headers })
            .then((res) => {
                setIsLoading(false);
                setGenerateComicData(res?.data?.data);
                setLoaderStatus("success");
                setCreditScore(res?.data?.credits);
                // Delay hiding the loader to improve user experience
                setTimeout(() => {
                    setIsLoader(false);
                }, 300);
            })
            .catch((error) => {
                setIsLoading(false);
                clearInterval(progressInterval);
                setLoaderStatus("error");
                console.log(error);
            });
    };
    useEffect(() => {
        const headers = { Authorization: `Bearer ${token}` };
        api
            .get("/get-credits", { headers })
            .then((res) => {
                setCreditScore(res?.data?.credit[0]?.credits);
            })
            .catch((error) => {
                console.log(error);
            });
    }, [token]);

    // user-profile API executes on page reload and populates style preferences
    useEffect(() => {
        setIsLoading(true);
        const headers = { 'Authorization': `Bearer ${token}` };
        api.get("/user-profile", { headers })
            .then((res) => {
                setIsLoading(false)
                const options = [
                    { value: 'manga', label: 'Manga' },
                    { value: 'western comic', label: 'Western Comic' },
                    { value: 'webtoon', label: 'Webtoon' },
                ]
                setCreationStyle(res?.data?.data?.creation_style_preference);
            })
            .catch((error) => {
                if (error.response) {
                    const errorData = error?.response?.data;
                    const backend = {};
                    if (errorData.messages) {
                        backend.messages = errorData?.messages[0]?.message;
                    }
                    if (errorData.error) {
                        backend.error = errorData?.error;
                    }
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log("Error: ", error?.message);
                }
            })
    }, [token]);
    const isMobile = useMediaQuery({ maxWidth: 700 });
  return (
    <div>
         <Accordion sx={{ marginInline: "20px", backgroundColor: "#111111" }}>
                {/* <AccordionSummary
                    expandIcon={<ExpandMore />}
                    sx={{
                        background:
                            "linear-gradient(98.49deg, #FCB808 -11.31%, #F9075E 76.26%)",
                        borderRadius: "10px",
                    }}
                >
                    <Typography sx={{ fontWeight: 600 }}>Storyboard</Typography>
                </AccordionSummary> */}
                <AccordionDetails sx={{ padding: "20px 0" }}>
                    <div className="container d-flex flex-column g-40">
                        {/* Prompt Input field section starts*/}
                        <form
                            autoComplete="off"
                            onSubmit={handleSubmitStoryboard(onSubmitStoryBoard)}
                        >
                            <div className={`${styles.row} g-20 justify-content-center`}>
                                {/* select image size starts */}
                                {/* <div className={`${styles.col_md_2}`}>
                                    <Controller
                                        name="imageRes"
                                        render={({ field }) => (
                                            <CustomSelect
                                                {...field}
                                                options={[
                                                    { value: '256x256', label: 'Low 🪙x1' },
                                                    { value: '512x512', label: 'Medium 🪙x2' },
                                                    { value: '1024x1024', label: 'High 🪙x3' },
                                                ]}
                                                placeholder={'Size'}
                                                selected={selectedOption}
                                                setSelected={setSelectedOption}
                                            />
                                        )}
                                        control={control}
                                        defaultValue={""}
                                    />
                                    {errors.imageRes && <small className={styles.error}>{errors.imageRes.message}</small>}
                                    {reqImageSize === true ? <small className={styles.error}>Image Size is required</small> : null}
                                </div> */}
                                {/* select image size ends */}

                                {/* input prompt starts */}
                                <div className={`${styles.col_md_8} d-flex align-items-center`}>
                                    <input
                                        className={classNames("field field--outline", {
                                            "field--error": errorsStoryboard.prompt,
                                        })}
                                        type="text"
                                        placeholder="📝 Prompt: A man is running through a forest."
                                        {...registerStoryboard("prompt", {
                                            required: "Prompt is required",
                                            pattern: {
                                                value: /^\S.*$/,
                                                message: "Early spaces are not allowed in prompt",
                                            },
                                        })}
                                    />
                                    {errorsStoryboard.prompt && (
                                        <small className={styles.error}>
                                            {errorsStoryboard.prompt.message}
                                        </small>
                                    )}
                                </div>
                                {/* input prompt ends */}

                                <div className="d-flex justify-content-between align-items-center g-8">
                                    {/* generate button starts */}
                                    <div className={styles.col_md_2}>
                                        {isLoading === false ? (
                                            <GradientBtn
                                                className={styles.btn}
                                                tag="button"
                                                type="submit"
                                            >
                                                Generate
                                            </GradientBtn>
                                        ) : (
                                            <GradientBtn
                                                className={styles.btn}
                                                tag="button"
                                                type="submit"
                                                disabled
                                            >
                                                <ClipLoader color="#ffffff" size={30} />
                                            </GradientBtn>
                                        )}
                                    </div>
                                    {/* generate button ends */}

                                    {/* shows total credits starts */}
                                    <div className={`${styles.col_md_2}`}>
                                        <span
                                            style={{
                                                color: "#F9075E",
                                                flexDirection: "column",
                                                display: "flex",
                                            }}
                                        >
                                            <FontAwesomeIcon
                                                className={styles.credits}
                                                icon={faCoins}
                                                size="lg"
                                                color="#FCB808"
                                            />{" "}
                                            {creditScore}
                                        </span>
                                    </div>
                                    {/* shows total credits ends */}
                                </div>
                            </div>
                        </form>
                        {/* Prompt Input field section ends*/}

                        {/* Image and progress bar section starts*/}
                        <div>
                            {loaderStatus === "error" && (
                                <p className={styles.error_msg}>
                                    Something Went Wrong. Try Again!
                                </p>
                            )}
                            {isLoader ? (
                                <>
                                    {/* on failure bonk gif will be displayed, on success draw gif will be displayed*/}
                                    <GifLoader
                                        uegif={loaderStatus === "error" ? bonkGIF : drawGIF}
                                    />

                                    {/* progress bar section starts */}
                                    <Progress
                                        percent={loaderStatus === "success" ? 100 : progress}
                                        status={loaderStatus}
                                        theme={{
                                            active: {
                                                color: "#FCB808",
                                            },
                                        }}
                                        style={{
                                            padding: isMobile ? "0 10% 0 15%" : "0 34% 0 36%",
                                            margin: "",
                                            color: "white",
                                        }}
                                    />
                                    {/* progress bar section ends */}
                                </>
                            ) : (
                                <>
                                    {generateComicData?.image?.length > 0 ? (
                                        <ItemsGrid images={generateComicData?.image} />
                                    ) : (
                                        // If no image is generated yet then static chibi image displays
                                        <NothingFound text="Let's Create" />
                                    )}
                                </>
                            )}
                        </div>
                        {/* Image and progress bar section ends*/}
                    </div>
                </AccordionDetails>
            </Accordion>
    </div>
  )
}

export default StoryBoard